import Axios from "axios";
import {
    SET_FULL_PAYROLL_LEDGER_REPORT_LIST, 
    UNSET_FULL_PAYROLL_LEDGER_REPORT_LIST
} from "@/store/mutation-types";
import {
    getFullPayrollLedgerReport,
} from "@/store/api";

const state = {
    getFullPayrollLedgerReport: [],
};

const getters = {
    getFullPayrollLedgerReport(state) {
        return state.getFullPayrollLedgerReport;
    },
};

const mutations = {
    [SET_FULL_PAYROLL_LEDGER_REPORT_LIST](state, data) {
        state.getFullPayrollLedgerReport = data;
    },
    [UNSET_FULL_PAYROLL_LEDGER_REPORT_LIST](state) {
        state.getFullPayrollLedgerReport = [];
    },
};

const actions = {

    getFullPayrollLedgerReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getFullPayrollLedgerReport}`, { params: data })
                .then((response) => {
                    commit(SET_FULL_PAYROLL_LEDGER_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_FULL_PAYROLL_LEDGER_REPORT_LIST);
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};